<script>
import DocumentDownloadButton from './DocumentDownloadButton.vue'
import mixinComponent from '../../Mixins/mixinComponent'

export default {
  components: { DocumentDownloadButton },
  mixins: [mixinComponent],

  props: {
    context: { type: String, required: true },
    contextId: { type: Number, required: true },
    restrict: { type: String, required: false },
    uuid: { type: String, required: false },
    internalname: { type: String, required: false },
    showCancel: { type: Boolean, default: false },
    downloadAction: { type: Boolean, default: false },
  },

  data: () => ({
    documents: [],
  }),

  methods: {
    getUrl() {
      const params = new URLSearchParams()

      params.append('contextId', this.contextId)
      params.append('context', this.context)

      if (this.restrict) {
        params.append('restrict', this.restrict)
      }
      if (this.uuid) {
        params.append('uniqid', this.uuid)
      }
      if (this.internalname) {
        params.append('internalname', this.internalname)
      }
      if (this.showCancel) {
        params.append('showCancel', '1')
      }

      let baseUrl = 'documents'
      if (this.uuid) {
        baseUrl = 'free/' + baseUrl
      }

      return `${baseUrl}?${params.toString()}`
    },
    getDocuments() {
      this.getJSON(this.getUrl()).then((json) => {
        this.documents = json.documents
        this.$emit('document-loaded', json)
      })
    },
  },

  beforeMount() {
    //TODO : revoir la récupération de documents pour faire en sorte de ne faire qu'un seul appel pour plusieurs documents -> remonter l'appel et gérer la liste
    this.getDocuments()
  },
}
</script>
<template>
  <!--          TODO : ajouter un loader pendant le chargement -->
  <div class="document-action">
    <template v-for="doc in documents" :key="doc.id">
      <DocumentDownloadButton v-if="downloadAction" :document="doc" :uuid="uuid" have-btn />
    </template>
  </div>
</template>
